export interface SignUpDetails {
  full_name: string;
  email: string;
  password: string;
  confirmPassword: string;
  phone_number: string;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[0-9\s\-()+.]+$/;
const MINIMUM_PASSWORD_LENGTH = 12;
const MINIMUM_PHONE_DIGITS = 10;

export const PASSWORD_HINT = 'At least 12 characters. A short phrase works well.';
export const PASSWORD_TOO_SHORT_MESSAGE = 'Use at least 12 characters.';
export const PASSWORD_EDGE_SPACE_MESSAGE = "Don't start or end your password with a space.";

const EDGE_WHITESPACE_PATTERN = /^\s|\s$/u;

export const isValidEmail = (value: string): boolean => EMAIL_PATTERN.test(value);

/** Counts code points, never more than the UTF-16 units or UTF-8 bytes the server may count. */
export const isPasswordLongEnough = (password: string): boolean =>
  [...password].length >= MINIMUM_PASSWORD_LENGTH;

export const hasEdgeWhitespace = (password: string): boolean =>
  EDGE_WHITESPACE_PATTERN.test(password);

/** Returns the first user-facing error for the sign-up details step, or null when valid. */
export const validateSignUpDetails = (details: SignUpDetails): string | null => {
  const missingFields: string[] = [];
  if (!details.full_name) missingFields.push('Full Name');
  if (!details.email) missingFields.push('Email');
  if (!details.password) missingFields.push('Password');

  if (missingFields.length > 0) {
    return `${missingFields.join(', ')} ${missingFields.length > 1 ? 'are' : 'is'} required`;
  }
  if (details.password !== details.confirmPassword) {
    return 'Passwords do not match';
  }
  if (hasEdgeWhitespace(details.password)) {
    return PASSWORD_EDGE_SPACE_MESSAGE;
  }
  if (!isPasswordLongEnough(details.password)) {
    return PASSWORD_TOO_SHORT_MESSAGE;
  }
  if (!isValidEmail(details.email)) {
    return 'Please enter a valid email address';
  }
  if (details.phone_number.trim()) {
    if (!PHONE_PATTERN.test(details.phone_number.trim())) {
      return 'Phone number must contain only numbers';
    }
    if (details.phone_number.replace(/[^0-9]/g, '').length < MINIMUM_PHONE_DIGITS) {
      return 'Phone number must be at least 10 digits';
    }
  }
  return null;
};
